import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import {
  ArrowLeft,
  Globe,
  ExternalLink,
  Settings,
} from 'lucide-react'
import { type Site, StatusBadge, HealthBadge } from './tabs/shared'

interface SiteDetailHeaderProps {
  site: Site
}

export function SiteDetailHeader({ site }: SiteDetailHeaderProps) {
  return (
    <header className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-14 items-center gap-4 px-4">
        {/* Back Button */}
        <Button variant="ghost" size="sm" asChild className="gap-2">
          <Link to="/dashboard/jezpress">
            <ArrowLeft className="h-4 w-4" />
            <span className="hidden sm:inline">Back to OAuth Sites</span>
          </Link>
        </Button>

        {/* Site Info */}
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <Globe className="h-5 w-5 text-muted-foreground shrink-0" />
          <div className="flex flex-col min-w-0">
            <span className="font-mono text-sm font-medium truncate">
              {site.domain}
            </span>
            {site.name && (
              <span className="text-xs text-muted-foreground truncate">
                {site.name}
              </span>
            )}
          </div>
        </div>

        {/* Status Badges */}
        <div className="hidden md:flex items-center gap-2">
          <StatusBadge status={site.status} />
          <HealthBadge lastActivityAt={site.last_activity_at} />
        </div>

        {/* Action Buttons */}
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" asChild className="hidden sm:flex">
            <a href={`https://${site.domain}`} target="_blank" rel="noopener noreferrer">
              <ExternalLink className="h-4 w-4 mr-2" />
              Visit
            </a>
          </Button>
          <Button variant="outline" size="sm" asChild>
            <a href={`https://${site.domain}/wp-admin/`} target="_blank" rel="noopener noreferrer">
              <Settings className="h-4 w-4 sm:mr-2" />
              <span className="hidden sm:inline">Admin</span>
            </a>
          </Button>
        </div>
      </div>
    </header>
  )
}
